import { Tooltip, TooltipProps } from "@fluentui/react-components";
import React, { ReactElement } from "react";

import styles from "./index.module.css";

export const MessagesTooltip: React.FC<{
  messages: string[];
  children: ReactElement;
  disabled?: boolean;
  // trigger に可視ラベルがある場合は "description" を渡す (既定の "label" は aria の名前を上書きする)
  relationship?: TooltipProps["relationship"];
}> = ({ messages, children, disabled, relationship = "label" }) =>
  disabled || messages.length === 0 ? (
    children
  ) : (
    <Tooltip
      content={<Messages messages={messages} />}
      relationship={relationship}
      withArrow
    >
      {children}
    </Tooltip>
  );

const Messages: React.FC<{
  messages: string[];
}> = ({ messages }) => {
  return (
    <ul className={styles.messageList}>
      {messages.map((message, idx) => (
        <li key={idx}>{message}</li>
      ))}
    </ul>
  );
};
